import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2 4.616A2.616 2.616 0 0 1 4.616 2H16.03a2.616 2.616 0 0 1 2.615 2.616V8.42a.713.713 0 1 1-1.427 0V4.616c0-.657-.532-1.19-1.189-1.19H4.617c-.657 0-1.19.533-1.19 1.19v15.22c0 .656.533 1.188 1.19 1.188h4.28a.713.713 0 1 1 0 1.427h-4.28A2.616 2.616 0 0 1 2 19.835V4.615Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.28 6.994c0-.394.32-.714.714-.714h6.658a.713.713 0 1 1 0 1.427H6.994a.713.713 0 0 1-.714-.713ZM16.268 14.604a.713.713 0 1 0-1.427 0v2.378c0 .394.32.713.714.713h1.902a.713.713 0 1 0 0-1.427h-1.189v-1.664Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.61 16.506a5.945 5.945 0 1 1 11.89 0 5.945 5.945 0 0 1-11.89 0Zm5.945-4.518a4.518 4.518 0 1 0 0 9.036 4.518 4.518 0 0 0 0-9.036Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }